var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealthAndMedicine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Monitor-Heart-Beat--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Monitor Heart Beat Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.76 12.39a0.5 0.5 0 0 0 0.42 -0.23l1 -1.61a1.59 1.59 0 0 1 1.44 -0.79 1.65 1.65 0 0 1 1.38 0.87l0.92 1.64a0.24 0.24 0 0 0 0.44 0L11 8.42a1.65 1.65 0 0 1 1.7 -1 1.7 1.7 0 0 1 1.44 1.34l1.33 5.56a0.27 0.27 0 0 0 0.22 0.19 0.27 0.27 0 0 0 0.26 -0.16l0.35 -0.85a1.68 1.68 0 0 1 1.53 -1.06h3.77a0.49 0.49 0 0 0 0.46 -0.31A11.4 11.4 0 0 0 23 7.75C23 3.14 20.32 0.87 17.67 0.67a5.61 5.61 0 0 0 -5.44 3.41 0.26 0.26 0 0 1 -0.46 0A5.6 5.6 0 0 0 6.33 0.67C3.68 0.87 1 3.14 1 7.75a11.4 11.4 0 0 0 0.94 4.33 0.49 0.49 0 0 0 0.46 0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.39 14.39a0.5 0.5 0 0 0 -0.46 0.31l-0.86 2.06a1.68 1.68 0 0 1 -1.53 1.06h-0.17a1.73 1.73 0 0 1 -1.45 -1.34l-1.33 -5.56a0.22 0.22 0 0 0 -0.22 -0.19 0.24 0.24 0 0 0 -0.25 0.15l-1.37 3.28a1.69 1.69 0 0 1 -1.41 1 1.62 1.62 0 0 1 -1.55 -0.86l-1 -1.84a0.25 0.25 0 0 0 -0.21 -0.13 0.27 0.27 0 0 0 -0.22 0.12l-0.72 1.15a1.63 1.63 0 0 1 -1.39 0.79H4a0.51 0.51 0 0 0 -0.44 0.26 0.49 0.49 0 0 0 0 0.51 29 29 0 0 0 7.9 8.05 1.15 1.15 0 0 0 1.1 0 29 29 0 0 0 7.9 -8 0.49 0.49 0 0 0 0 -0.51 0.51 0.51 0 0 0 -0.44 -0.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealthAndMedicine);
export default ForwardRef;